module.exports = __webpack_public_path__ + "img/1550209276.8fe8821c.jpg";